import { render, staticRenderFns } from "./OrderDialogTablePoint.vue?vue&type=template&id=5bf2d41b"
import script from "./OrderDialogTablePoint.vue?vue&type=script&lang=ts"
export * from "./OrderDialogTablePoint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports